export default {
  label: {
    title: 'Crear componente',
    data: {
      title: 'Datos',
    },
    details: {
      title: 'Detalles',
      titleInput: 'Título',
      descriptionInput: 'Descripción',
    },
    sensitiveData: {
      label: 'Datos sensibles (LGPD)',
    },
    viewControl: {
      title: 'Control de visualización',
      featureFlag: 'Feature Flag',
    },
    button: {
      apply: 'Aplicar',
      cancel: 'Cancelar',
      clearAll: 'Limpiar Todo',
    },
  },
  errorMessage: {
    default: 'Campo obligatorio.',
    invalidValues: 'Valores inválidos.',
    details: {
      title: 'El título debe tener como máximo 50 caracteres.',
      description: 'La descripción debe tener como máximo 200 caracteres.',
    },
  },
  message: {
    createComponent: 'Componente creado con éxito.',
  },
};

